// extracted by mini-css-extract-plugin
module.exports = {"campagin_DropDown":"index_campagin_DropDown__oKk5G","spanlight_hover":"index_spanlight_hover__3xSvO"};